import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import CheckBoxLabel from './CheckBoxLabel';

const Checkbox = styled((props) => {
  return (
    <Field name={props.name}>
      {({ field, form }) => (
        <CheckBoxLabel
          isDisabled={props.isDisabled}
          backgroundVariant={props.backgroundVariant}
        >
          <input
            {...field}
            disabled={props.isDisabled}
            type="checkbox"
            checked={field.value.includes(props.value)}
            onChange={() => {
              const set = new Set(field.value);
              if (set.has(props.value)) {
                set.delete(props.value);
              } else {
                set.add(props.value);
              }
              form.setFieldValue(field.name, Array.from(set), false);
            }}
          />
          {props.label}
        </CheckBoxLabel>
      )}
    </Field>
  );
})``;

export default Checkbox;
